import { pcbLayoutNestedNodeDelimiter, PcbNodeTypes, } from "@buildwithflux/models";
import { devAssert } from "../../../helpers";
import { getAncestorUidByType } from "../../../nodes";
/**
 * This walks up the tree of nodes then down the tree of elements.
 */
export function getAncestorElementData(nodeData, pcbLayoutNodes, elements, logger) {
    const footprintAncestorNodeUid = getAncestorUidByType(pcbLayoutNodes, nodeData.uid, PcbNodeTypes.element);
    if (!footprintAncestorNodeUid) {
        return undefined;
    }
    const [baseElementUid, ...nestedElementUids] = footprintAncestorNodeUid.split(pcbLayoutNestedNodeDelimiter);
    let element = elements[baseElementUid];
    while (nestedElementUids.length) {
        const nestedElementUid = nestedElementUids.shift();
        const extracted_element_cache = element?.part_version_data_cache?.extracted_element_cache ?? {};
        element = extracted_element_cache[nestedElementUid];
        // NOTE: devAssert only here because the original code returned
        // undefined and some projects have been observed to have this issue.
        // See https://edge.flux.ai/greg/test-add-generic-relay
        // See https://edge.flux.ai/projects/c3c6b4a2-0417-074a-49b0-e33a5efcc971
        devAssert(element, `nested element ${nestedElementUid} does not exist in element cache of ${element?.label}`, logger);
    }
    return element;
}
//# sourceMappingURL=getAncestorElementData.js.map